import { connect } from 'react-redux'
import { UpdateFormComponent } from './UpdateFormComponent'
import { resetPasswordUpdate } from 'shared/store/reset-password'
import type { RootState } from 'shared/store/reducers'
import type { Dispatch } from 'redux'
import type { NewPasswordForm } from 'shared/types'

const mapStateToProps = (state: RootState) => state.resetPasswordPageState

const mapDispatchToProps = (d: Dispatch<any>) => ({
    updatePassword: (form: NewPasswordForm) => d(resetPasswordUpdate(form))
})

const UpdateForm = connect(
    mapStateToProps,
    mapDispatchToProps
)(UpdateFormComponent)

export { UpdateForm }
